import logo from "../assets/images/logo.png";
import SocialMedia from "./SocialMedia";

function Footer() {
  return (
    <footer className="bg-black py-10 px-20 text-white flex justify-start items-center gap-3 max-md:flex-col max-md:px-10 max-md:justify-center max-md:items-center">
      <article className="flex-1 max-md:text-center max-md:flex justify-center items-center max-md:flex-col ">
        <a href="">
          <img src={logo} alt="logo" />
        </a>
        <p className="w-[70%] my-6 max-md:w-[90%] max-md:text-[13px] opacity-[.5] text-[15px] font-regular font-normal">
          Thank you for visiting my portfolio. If you have any questions or
          would like to discuss potential projects, please don't hesitate to get
          in touch
        </p>
        <SocialMedia />
      </article>
      <article className="flex-1 max-md:flex justify-center items-center max-md:flex-col max-md:text-center">
        <h3 className="text-yellow text-[20px]">Quick Links</h3>
        <ul>
          <li>
            <a className="font-semibold" href="#hero">
              Home
            </a>
          </li>
          <li>
            <a className="font-semibold" href="#about">
              About Me
            </a>
          </li>
          <li>
            <a className="font-semibold" href="#project">
              Projects
            </a>
          </li>
          <li>
            <a className="font-semibold" href="#contact">
              Contact
            </a>
          </li>
        </ul>
      </article>
    </footer>
  );
}

export default Footer;
